import { newConfig } from "../bizfly-shared";

export async function getNewEndpoint() {
  const config = await newConfig();

  const BASE_BACKEND_URL = config?.base?.backendUrl;
  const IC_BACKEND_URL = config?.services["iaas-cloud"]?.backendUrl;
  const AUTH_BACKEND_URL = config?.base?.authBackendUrl;
  const BILLING_BACKEND_URL = config?.services?.billing?.backendUrl;
  const ACCOUNT_BACKEND_URL = config?.services?.account?.backendUrl;
  const BILLING_BACKEND_V4_URL = config?.services?.billing?.backendUrlV4;

  return {
    SSL: `${BASE_BACKEND_URL}/ssl`,
    TRIALS: `${AUTH_BACKEND_URL}/trials`,
    TEMP_BALANCES: `${AUTH_BACKEND_URL}/temp_balances`,
    REGIONS: `${AUTH_BACKEND_URL}/regions`,
    INVOICES: `${AUTH_BACKEND_URL}/invoices`,
    IMAGES: `${IC_BACKEND_URL}/images`,
    VOLUME_TYPES: `${IC_BACKEND_URL}/volume-types`,
    SERVER_TYPES: `${IC_BACKEND_URL}/server-types`,
    FLAVORS: `${IC_BACKEND_URL}/flavors`,
    PREBUILD_APPS: `${IC_BACKEND_URL}/prebuild_apps`,
    VPC_NETWORKS: `${IC_BACKEND_URL}/vpc-networks`,
    NETWORK_INTERFACES: `${IC_BACKEND_URL}/network-interfaces`,
    SSH_KEYS: `${IC_BACKEND_URL}/keypairs`,
    PRICE: `${BILLING_BACKEND_URL}/api/v4.1/pricing`,
    USER_INFO: config?.base?.userInfoUrl,
    TICKET: config?.base?.ticketUrl,
    BILLING: `${BILLING_BACKEND_URL}`,
    QUOTAS: `${IC_BACKEND_URL}/quotas`,
    ACCOUNT: ACCOUNT_BACKEND_URL,
    CREDIT_CARD: `${BILLING_BACKEND_V4_URL}/credit-cards`,
    PLANS: `${IC_BACKEND_URL}/plans`,
  };
}
